import { render, staticRenderFns } from "./FoodMenuGalleryDialog.vue?vue&type=template&id=1901a5de"
import script from "./FoodMenuGalleryDialog.vue?vue&type=script&lang=js"
export * from "./FoodMenuGalleryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports